import { UtilService } from 'app/_services/util.service';
import { TransmissionSystemOperatorResource } from 'app/_resources/transmission-system-operator.resource';
import * as angular from 'angular';
import * as moment from 'pkp-moment-timezone-all-years';

(function () {
    'use strict';

    angular
        .module('app')
        .controller('FcfsBookingStageTwoCtrl', FcfsBookingStageTwoCtrl);

    function FcfsBookingStageTwoCtrl(
        $log,
        $scope,
        $filter,
        $location,
        GENERAL_ERROR,
        Fcfs,
        fcfsBookingService,
        INCLUDE,
        utilService: UtilService,
        TransmissionSystemOperator: TransmissionSystemOperatorResource
    ) {
        var vm: {
            networkPoint: NetworkPointDto;
            [propertyName: string]: any;
        } = this;

        vm.INCLUDE = INCLUDE;
        vm.submit = submit;
        vm.generalError = GENERAL_ERROR;
        vm.fcfsConfigLoading = true;

        vm.ui = {
            isPrimaryTradingSupported: true,
            generalError: false,
            checkingAvailability: false
        };
        fcfsBookingService.resetAllStagesAfter(2);
        vm.data = fcfsBookingService.getStageTwo();
        vm.datatsos = fcfsBookingService.getStageOne();
        vm.networkPoint = fcfsBookingService.getStageOne().selectedNetworkPoint;
        vm.capacity = fcfsBookingService.capacity;
        vm.onCustomRuntimePickerChange = onCustomRuntimePickerChange;
        vm.preSetRuntimeEnd = preSetRuntimeEnd;

        if (vm.networkPoint.bundled) {
            vm.suggestedRuntimes =
                TransmissionSystemOperator.getNextBookableFcfsRuntimes({
                    id: vm.networkPoint.tso0Id
                }); // within-day fcfs bookings are only possible for unbundled network points
        } else {
            vm.suggestedRuntimes =
                TransmissionSystemOperator.getNextBookableFcfsWithinDayRuntimesAtNetworkPoint(
                    {
                        id: vm.networkPoint.tso0Id,
                        npId: vm.networkPoint.id
                    }
                ); // within-day fcfs bookings are only possible for unbundled network points
        }

        vm.allowCustomRuntimesForWithinDayBookings = false; // within-day fcfs bookings are only possible for unbundled network points
        vm.allowWithinDayFcfsBookings = false; // within-day fcfs bookings are only possible for unbundled network points

        TransmissionSystemOperator.getAllowCustomRuntimesForWithinDayBookings(
            { id: vm.networkPoint.tso0Id },
            (result) => {
                vm.allowCustomRuntimesForWithinDayBookings = result.data;
            }
        );
        TransmissionSystemOperator.getAllowWithinDayFcfsBookings(
            { id: vm.networkPoint.tso0Id },
            (result) => {
                vm.allowWithinDayFcfsBookings = result.data;
            }
        );
        TransmissionSystemOperator.queryFcfsSettings(
            { id: vm.networkPoint.tso0Id },
            (res: TsoFcfsSettingsDto) => {
                vm.allowFcfsStandardRuntimesOnly = res.fcfsStandardRuntimesOnly;
                vm.allowFcfsStandardRuntimesOnlyNote =
                    res.fcfsStandardRuntimesOnlyNote;
                if (res.fcfsStandardRuntimesOnly) {
                    // PRISMA-7125
                    vm.maxRuntimeStart = (
                        moment(new Date(2019, 11, 31, 6)) as moment.Moment
                    ).toDate();
                    vm.indexOfSelectedSuggestedRuntime = -1;
                }
            }
        );

        //Initial check for FCFS config
        function getFcfsConfig() {
            Fcfs.getFcfsConfig(
                {
                    networkPointId: vm.networkPoint.id
                },
                function (res) {
                    vm.config = res;
                    if (
                        vm.config.tsoMaintenanceMessages &&
                        vm.config.tsoMaintenanceMessages.length
                    ) {
                        fcfsBookingService.tsoMaintenanceMessages =
                            vm.config.tsoMaintenanceMessages;
                        $location.path('/fcfs-booking-maintenance');
                    }
                    vm.fcfsConfigLoading = false;
                },
                function () {
                    vm.fcfsConfigLoading = false;
                }
            );
        }

        getFcfsConfig();

        if (angular.isUndefined(vm.data.interval)) {
            vm.data.interval = {};
        }
        if (angular.isUndefined(vm.data.capacity)) {
            vm.data.capacity = {};
        }
        if (angular.isUndefined(vm.data.capacity.unit)) {
            if (vm.networkPoint.physicalUnit === 'K_WH_H') {
                vm.data.capacity.unit = vm.capacity.unit.KWH_H;
            } else {
                vm.data.capacity.unit = vm.capacity.unit.KWH_D;
            }
        }

        vm.ui.isPrimaryTradingSupported = checkPrimaryTradingSupport();

        function submit(form: ng.IFormController) {
            if (!form.$valid || !checkPrimaryTradingSupport()) {
                $scope.wizard.goToTop();
                return false;
            }

            vm.ui.checkingAvailability = true;
            Fcfs.checkAvailability(
                mapDataToCapacityRequest(),
                function (res) {
                    vm.ui.checkingAvailability = false;
                    vm.data.checkResponse = res;
                    // copy data to a special checked property to prevent manipulation afterwards
                    vm.data.checked = {};
                    vm.data.checked.interval = angular.copy(vm.data.interval);
                    vm.data.checked.capacity = angular.copy(vm.data.capacity);
                    vm.data.checked.capacityCategory0 = angular.copy(
                        vm.data.capacityCategory0
                    );
                    vm.data.checked.capacityCategory1 = angular.copy(
                        vm.data.capacityCategory1
                    );
                    vm.data.checked.networkPoint = angular.copy(
                        vm.networkPoint
                    );

                    fcfsBookingService.setStageTwo(vm.data);
                    $scope.wizard.goToNextStage();
                },
                function (err) {
                    if (err && err.data && err.data.message) {
                        vm.ui.errorResponse = err.data.message;
                    } else {
                        vm.ui.generalError = true;
                    }
                    vm.ui.checkingAvailability = false;
                }
            );

            return true;
        }

        function checkPrimaryTradingSupport() {
            var result = false;
            if (vm.networkPoint && vm.networkPoint.tradingMarkets0) {
                result =
                    $filter('filter')(
                        vm.networkPoint.tradingMarkets0,
                        'Primary'
                    ).length > 0;
            }
            return result;
        }

        function mapDataToCapacityRequest() {
            return {
                runtime: vm.data.interval,
                capacityCategory0: vm.data.capacityCategory0,
                capacityCategory1: vm.data.capacityCategory1,
                networkPointId: vm.networkPoint.id,
                quantity: vm.data.capacity
            };
        }

        function onCustomRuntimePickerChange() {
            if (
                vm.data.interval != null &&
                vm.data.interval.start != null &&
                vm.data.interval.end != null &&
                vm.indexOfSelectedSuggestedRuntime == null
            ) {
                vm.indexOfSelectedSuggestedRuntime = -1;
            }
        }

        function preSetRuntimeEnd(periodType: PeriodType) {
            if (
                vm.data.interval == null ||
                vm.data.interval.start == null ||
                periodType == null
            )
                return;
            const start: moment.Moment = moment(vm.data.interval.start);

            let preSetEnd: moment.Moment;

            if (periodType === 'WITHINDAY' || periodType === 'DAY') {
                preSetEnd = moment(
                    utilService.getNextGasDayStart(start.unix() * 1000)
                );
            } else if (periodType === 'MONTH') {
                preSetEnd = start.add(1, 'month');
            } else if (periodType === 'QUARTER') {
                preSetEnd = start.add(3, 'month');
            } else if (periodType === 'YEAR') {
                preSetEnd = start.add(1, 'year');
            } else {
                console.warn(`${periodType} not expected.`);
                return;
            }

            vm.data.interval = {
                start: vm.data.interval.start,
                end: preSetEnd.toDate()
            };
        }
    }
})();
